import type { TAngle } from "~/videos/schemas/event-upload.schema";
import type { ISportAngle, TResponseSportAngle } from "~/videos/types/event-angles";

export function formatAngles(angles: TAngle[], primaryAngle: string | null): TEventAngles {
  return angles.map(angle => ({
    name: angle.name,
    primary: angles.length > 1 ? angle.name === primaryAngle : true,
    videos: angle.files.map((item, index) => ({ index, url: item.key, duration: item.duration })),
  }));
}

export function formatSportAngle(angle: TResponseSportAngle): ISportAngle {
  return {
    name: angle.angleName ?? "",
    label: angle.label ?? "",
    shortName: angle.angleShortName ?? "",
    vsId: angle.angleVSId ?? 0,
  };
}
